import { render, staticRenderFns } from "./FooterTatal.vue?vue&type=template&id=34d00bc0&scoped=true"
import script from "./FooterTatal.vue?vue&type=script&lang=js"
export * from "./FooterTatal.vue?vue&type=script&lang=js"
import style0 from "./FooterTatal.vue?vue&type=style&index=0&id=34d00bc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d00bc0",
  null
  
)

export default component.exports